import { AppBar, Container, List, ListItem, ListItemIcon, ListItemText, Toolbar, Typography } from "@material-ui/core";
import { WebAsset } from "@material-ui/icons";
import React from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import templates from './templates';

export default function App() {
  return (
    <Router>
      <div>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          {templates.map(({ name, path, component })=> {
            return (
              <Route key={name} exact path={path}>
                {component}
              </Route>
            )
          })}
        </Switch>
      </div>
    </Router>
  );
}

function ListItemLink(props) {
  return <ListItem button component={Link} {...props} />;
}


function Home() {
  return (
    <div>
      <AppBar position="relative">
        <Toolbar>
          <Typography variant="h5">Grinder Templates</Typography>
        </Toolbar>
      </AppBar>
      <Container>
        <List component="nav" aria-label="main mailbox folders">
          {templates.map(({ name, testPath, icon = <WebAsset /> })=> {
            return (
                <ListItemLink key={name} to={testPath}>
                  <ListItemIcon>
                    {icon}
                  </ListItemIcon>
                  <ListItemText>{name}</ListItemText>
                </ListItemLink>
              )
          })}
        </List>
      </Container>
    </div>
  );
}

